import Vue from "vue";
import routes from "../src/router";
import Store from "../src/store";
import App from "./App.vue";

import vuetify from "./plugins/vuetify";
import axiosInstance from "./plugins/axios";
import VueCookies from "vue-cookies";

import localizationFactory from "./plugins/localization";
import filters from "./filters";
import timer from "./plugins/timer";
import moment from "moment-timezone";
import excel from 'vue-excel-export'

const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = '/plateau_ui/plateau_ui.js';
  s.id="plateau_ui_script"
  document.body.appendChild(s);

  var containerServices = {
    getURL(url, mode) {
      if(mode=='ui') {
      // return "http://localhost:8080" + url  
      // return "http://caperaui.capera-int.capera.plateaux.softtech" + url
      }
    }
  }


  setTimeout(()=> {
    window.plateau_ui.setContainerServices(containerServices)
  }, 10000)

localizationFactory().then(function(plugin) {
  moment.tz.setDefault("Europe/Istanbul");

  Vue.prototype.$http = axiosInstance;
  Vue.prototype.$eventHub = new Vue();
  Vue.use(VueCookies);
  Vue.use(plugin);
  Vue.use(filters);
  Vue.use(timer);
  Vue.use(excel);
  new Vue({
    el: "#app",
    vuetify,
    router: routes,
    store: Store,
    render: h => h(App)
  });
});



// WEBPACK FOOTER //
// ./src/main.js